import Vue from 'vue'
import store from '../store/'
import VueSocketIO from 'vue-socket.io'
import Config from '@/config'
 
Vue.use(new VueSocketIO({
    debug: true,
    connection: Config.url,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}))